import ForgetasswordForm from './lib/form';

import * as S from './styles';
import { Link } from 'react-router-dom';

export default function ForgetasswordChangePage() {
  return (
    <S.AuthContainer>
      <S.FormLogin>
        <S.FormTitle>Change your password</S.FormTitle>
        <S.SubTitle>Choose a new password for your Frontline account.</S.SubTitle>
        <ForgetasswordForm />
        <S.Foot>
          <S.Div>
            Didn&apos;t receive a confirmation email? <Link to="/auth/forget-password">Request a new one</Link>
          </S.Div>
          <S.Div>
            Already have login and password? <Link to="/auth/login">Sign in</Link>
          </S.Div>
        </S.Foot>
      </S.FormLogin>
    </S.AuthContainer>
  );
}
